$(document).ready(function(){
  if($('body.product')){  
    let desc_wrap = $('.description_content');
    desc_wrap && desc_wrap.each(function(){
      $(this).wrapInner(`<div class="desc_content"></div>`);
      $(this).append(`<div id="desc_toogler"><a href="#">Show more</a></div>`);
      let heightContent = $(this).height();
      if(heightContent > 200){
        desc_wrap.addClass("showMore");
        $('.desc_content').addClass("hideContent");
      }
      
    })
    if($("#desc_toogler a")){
      $("#desc_toogler a").on("click", function(e) {
        e.preventDefault();
        let $this = $(this); 
        let $content = $this.parent().prev(".desc_content");
        let linkText = $this.text().toUpperCase();    
        
        if(linkText === "SHOW MORE"){
          linkText = "Show less";
          $content.toggleClass("hideContent");
        } else {
          linkText = "Show more";
          $content.toggleClass("hideContent");
        };
    
        $this.text(linkText);
      });
    }

    const defaultNoticeInnerHTML = `<p class="customily_modal_preview--title">Please check the preview carefully</p> <p class="customily_modal_preview--notice_content"><em>Make sure the below customization is correct to receive your item faster</em></p>`
    function handleFakeBtnClick(t) {
      t.stopPropagation(),
        document.querySelector(".btn-preview-add-to-cart").classList.add("running");
      document.querySelector(".add_to_cart_js").click();
    }
    function mainFunc(item) {
      if (item.classList !== null && item.classList !== void 0) {
        if (item.classList.contains('canvas-container')) {
          var t = document.querySelector(".add_to_cart_js");
          
          e = document.querySelector(".customily-modal-preview-only .main");
          t.classList.add("btn-preview-add-to-cart");
          e.appendChild(t);
          t.addEventListener("click", function (t) {
            return handleFakeBtnClick(t);
          });
          const formWrapper = document.querySelector('.product_form');
          
          var modifyNoticeEl = document.createElement('div');
          modifyNoticeEl.className = 'customily_modal_preview--modify_notice';
          
          modifyNoticeEl.innerHTML = defaultNoticeInnerHTML;
          e.appendChild(modifyNoticeEl)
        }
      }
    }  
    (function () {
      try {
        const observer = new MutationObserver(function (t) {
          t.forEach(function (t) {
            if (t.addedNodes) {
              for (var r = 0; r <t.addedNodes.length; r++) {
                var e = t.addedNodes[r];
                mainFunc(e);
              }
            }
      
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }

  function personalisation() {
    function handleChecked(el){
      if (el.val() === "no") {
        el.parents(".product_properties").find(".properties_custom__error").hide();
        el.parents(".layoutInput").find(".noCustom").val("Customer requires no text").removeAttr("disabled");
        el.parents(".layoutInput").find(".properties_custom input").attr("disabled", "disabled").hide();
        el.parents(".layoutInput").find(".properties_custom").hide();
        $('.ajax-submit').prop("disabled", false);
      } else {
        el.parents(".product_properties").find(".properties_custom__error").hide();
        el.parents(".layoutInput").find(".noCustom").attr("disabled", "disabled").val("");
        el.parents(".layoutInput").find(".properties_custom input").removeAttr("disabled").show();
        el.parents(".layoutInput").find(".properties_custom").show();
        $('.ajax-submit').prop("disabled", true);
      }
    }
  
    $(".properties_custom input").keyup(function () {
      const _this = $(this);

      const maxLength = _this.attr('maxlength');
      if (_this.val().length > maxLength) {
        _this.val(_this.val().slice(0, maxLength));
      }
      
      if (_this.val().trim() == "") {
        _this.parents(".product_properties").find(".properties_custom__error").show();
        _this.css("border", "1px solid red");
        $('.ajax-submit').prop("disabled", true);
        flag = false;
      } else {
        _this.parents(".product_properties").find(".properties_custom__error").hide();
        _this.css("border-color", "#e3e3e3");
        $('.ajax-submit').prop("disabled", false);
      }
    });
  
    $(".btn-radio__checked").each(function () {
      if ($(this).val() === "no") {
        $(this).attr("checked", true);
        handleChecked($(this));
      }
    });
  
    $(document).on("change", ".btn-radio__checked", function () {
      handleChecked($(this));
    });
  }

//   window.addEventListener("customily-preview-modal-show", function () {
//   const a = document.querySelector(".customily-modal-preview-only");
//   const cl = document.querySelector(".product_gallery > .cl-canvas-container");
//   const h = document.querySelector(".customily-close-button");
//   const t = document.querySelector(".canvas-wrapper");
//   const e = document.querySelector(".customily-modal-preview-only .main");
  
//   h.addEventListener('click', function () {
//     if(cl){
//       cl.appendChild(t);
//     }
//   })
//   a.addEventListener('click', function (e) {
//     e.target === a && cl && cl.appendChild(t);
//   });

//   let count = 0;
//   const index = setInterval(() => {
//     count++;
//     if(count > 8){
//       clearInterval(index);
//     }
//     if(e.classList.contains('cl-use-image')){
//       e.insertBefore(t, e.children[0]);
//       clearInterval(index);
//     } 
    
//   }, 100);
// });
  
  personalisation();
});

const dataLayerATC = function(cart){
  const data = [{
    item_id: cart.product_id,
    item_variant_id: cart.variant_id,
    item_name: cart.product_title || cart.title,
    item_brand: cart.vendor,
    item_category: cart.product_type,
    price: cart.price/100.00,
    quantity: cart.quantity,
    variant_title: cart.variant_title
  }]
  
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "add_to_cart",
    ecommerce: {
      currency: window.PXUTheme.currency.default_currency,
      value: cart.final_line_price/100.00,
      items: data
    }
  });
}

function dataLayerAtc(action){
  const $addToCartForm = action.closest('form');
  const $addToCartBtn = $addToCartForm.find('.add_to_cart');

  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $addToCartForm.serialize(),
    success(addCart) {
      dataLayerATC(addCart);
    }
  });
}

const elAtcTypeBtn = $('.add_to_cart_js[type="button"]');
const elAtcTypeSubmit = $('.add_to_cart_js[type="submit"]');
if(elAtcTypeBtn){
  $(document).on('click', '.add_to_cart_js', function (e) {
    dataLayerAtc($(this));
  });
}
if(elAtcTypeSubmit){
  $(document).on('submit', '.add_to_cart_js', function (e) {
    dataLayerAtc($(this));
  });
}

